<template>

  <v-row class="inner-content">
    <v-col>
      <DiscountsTable />
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: 'DiscountsList',

  components: {
    DiscountsTable: () => import('@/components/tables/DiscountsTable.vue')
  },
}
</script>
